import apiRequest from './apiRequest';
import { Character } from './getCharacters';

type Payload = {
  wsHttpEndpoint: string;
  wsConnectionID: string;
};

export default async function postWsAndFetchCharacter(
  characterID: string,
  data: Payload,
) {
  return await apiRequest<Character>(
    'mogen-orchestration',
    `/characters/ws/${characterID}`,
    {
      method: 'POST',
      body: JSON.stringify(data),
    },
  );
}
